import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchBankListApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_BANK_LIST_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchBankListApiCall(actions) {
	const { callback, stopLoader } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.CONSUMER,
		url: API_CONSTANT.URL.BANK_LIST,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data;
		callback && callback(apiData);
		yield put(triggerFetchBankListApiCallSuccess(apiData));
	}
}

export default function* triggerFetchBankListApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_BANK_LIST_API, triggerFetchBankListApiCall);
}
